// Calm transition band: connected nodes with a shimmer flowing along the
// segments — suggests knowledge linking together.
const Segment = ({ gradient, delay }: { gradient: string; delay: string }) => (
  <span className={styles.seg} style={{ background: gradient }}>
    <span className={styles.shimmer} style={{ animationDelay: delay }} />
  </span>
);

export const Separator4 = () => (
  <div className={styles.band} aria-hidden="true">
    <span
      className={styles.node}
      style={{
        background: '#FDE47A',
        boxShadow: '0 0 10px rgba(247,203,45,0.7)',
      }}
    />
    <Segment gradient="linear-gradient(90deg,#FDE47A,#7fa8ff)" delay="0s" />
    <span
      className={styles.node}
      style={{
        background: '#7fa8ff',
        boxShadow: '0 0 10px rgba(127,168,255,0.8)',
      }}
    />
    <Segment gradient="linear-gradient(90deg,#7fa8ff,#6ed7a6)" delay="1.8s" />
    <span
      className={styles.node}
      style={{
        background: '#6ed7a6',
        boxShadow: '0 0 10px rgba(110,215,166,0.8)',
      }}
    />
  </div>
);

const styles = {
  band: 'flex h-[150px] items-center justify-center bg-mf-navy',
  node: 'h-[9px] w-[9px] flex-shrink-0 rounded-full',
  seg: 'relative h-[2px] w-24 overflow-hidden rounded-[2px]',
  shimmer:
    'absolute top-0 left-[-45%] h-full w-[45%] [background:linear-gradient(90deg,transparent,rgba(255,255,255,0.9),transparent)] motion-safe:animate-sep-flow',
};
